export default ({ fields, ...rest }) => ({
  ...rest,
  ...fields.reduce((o, { name, value }) => ({ ...o, [name]: value }), {}),
})
